<template>
  <div>

   <label class="col-form-label font-weight-bold"> {{text}} </label>
         
       <div>  
   <input type="radio"  v-model="opcao" name="opcao"  :value="value_op1" :disabled="disabled" :readonly="readonly">
   <label class="col-form-label font-weight-bold"> {{text_op1}} </label>
       
         </div>
     <div >
    <input type="radio" v-model="opcao" name="opcao" :value="value_op2" :disabled="disabled" :readonly="readonly">
   <label class="col-form-label font-weight-bold"> {{text_op2}} </label>
   
  </div>
  
  </div>
</template>

<script>
export default {

  data(){
    return{
      valor : '',
      newvalor : '',
      opcao : Number,
    }
  },

props: {
  text : String,
  tipo : String,
  placeholder : '',
  readonly : String,
  disabled : String,
  valor : String,
  text_op1 : String,
  text_op2 : String,
  value_op1 : String,
  value_op2 : String,
},

watch : {
  
  opcao(val){       
    this.$emit('eventInputRadio', val)
   }
}

}
</script>

<style scoped >
.flex{
 
display: flex;
   
}




</style>